import { TopImpactValueType } from "src/organization/pages/project/environment/metrics/http2/impact/types";

export const sortMetricsByImpact = (
  a: TopImpactValueType,
  b: TopImpactValueType
) => {
  const sumA = a.impact || 0;
  const sumB = b.impact || 0;
  return sumB - sumA;
};
